<template>
  <div class="">
    <section class="map">
      <div id="soulmap">
        <GmapMap
          v-if="mapMarkers.length > 0"
          ref="map"
          :center="map.center"
          :zoom="map.zoom"
          :options="mapOptions"
          style="margin: 0 auto; width: 100%; height: 600px"
        >
          <GmapMarker
            v-for="(mapMarker, index) in mapMarkers"
            :key="index"
            :position="{ lat: mapMarker.lat, lng: mapMarker.lng }"
            :clickable="true"
            :draggable="false"
            :options="{
              optimized: false,
            }"
            @click="toggleInfoWindow(mapMarker, mapMarker.id)"
          />

          <GmapInfoWindow
            :opened="infoWindow.open"
            :position="infoWindow.position"
            :options="infoWindow.options"
            @closeclick="closeInfoWindow()"
          >
            <div v-html="infoWindow.content" />
          </GmapInfoWindow>
        </GmapMap>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable global-require */

import { sync } from 'vuex-pathify';

import map from '@/mixins/pages/map';
import mapOptions from '@/mixins/pages/map-options';
// import mapClusters from '@/mixins/pages/map-clusters';
import mapInfoWindow from '@/mixins/pages/map-info-window';

export default {
  mixins: [
    map, //
    mapOptions, //
    // mapClusters, //
    mapInfoWindow, //
  ],

  props: {
    mapMarkers: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...sync([
      'map', //
    ]),
  },

  created() {
    Bus.$emit('loading', true);
  },

  methods: {
    toggleInfoWindow(marker, id) {
      // this.setCenter({
      //   lat: marker.lat,
      //   lng: marker.lng,
      // });

      this.infoWindow.position = { lat: marker.lat, lng: marker.lng };
      this.infoWindow.content = `
                <div class="mapInfoWindow">
                    There are ${marker.users} nomads in ${marker.city}, ${marker.country}
                </div>
                `;

      if (this.infoWindow.id === id) {
        // same -> toggle between visibility
        this.infoWindow.open = !this.infoWindow.open;
        this.infoWindow.id = marker.id;
      } else {
        // not same -> open the new one
        this.infoWindow.open = true;
        this.infoWindow.id = marker.id;
      }
    },
  },
};
</script>

<style lang="scss">
#soulmap {
  .mapInfoWindow {
    position: relative;
    text-align: left;
    padding: 5px 0 5px 15px;
    font-size: 16px;
    // line-height: 22px;
    a {
      color: #04b9b2;
    }
    img {
      border-radius: 50%;
      border: 5px solid #eee;
      width: 33.33%;
      float: left;
      margin-right: 20px;
    }
  }
  img[src*='map.jpg'] {
    width: 90%;
    border-radius: 50%;
    border: 1px solid #eee;
  }
}

@media (max-width: 767px) {
  #soulmap .mapInfoWindow {
    font-size: 1.4rem;
    padding: 0;
    line-height: 20px;
  }
}
</style>
